import { ISingleIdParams } from '../types/actionParams';
import { FlowAllowedActions } from '../types/FlowAllowedActions';
import { Request } from './Request';

export class GetFlowActionsRequest extends Request<ISingleIdParams, FlowAllowedActions> {
  constructor(id: string) {
    super('getFlowActions', { id: id });
  }
}
